import { createCrudSagas } from './CrudSagas'
import { AlertsActions } from '../reducers/AlertsRedux'

// service name must be lowercase to match backend Feathers service
const crudSagas = createCrudSagas('alerts', AlertsActions)

export const findAlerts = crudSagas.findAlerts
export const getAlert = crudSagas.getAlert
export const createAlert = crudSagas.createAlert
export const updateAlert = crudSagas.updateAlert
export const watchAlerts = crudSagas.watchAlerts;
export const unwatchAlerts = crudSagas.unwatchAlerts;

